import { Routes } from '@angular/router';

import { IndicationUtmBlockGuard } from '../core/guards/indication-utm-block.guard';
import { IndicationComponent } from '../pages/indication/indication.component';
import { IndicationPmeComponent } from '../pages/indication-pme/indication-pme.component';

export const indicationRoutes: Routes = [
  {
    path: 'indica',
    component: IndicationComponent,
    canActivate: [IndicationUtmBlockGuard],
  },
  {
    path: 'indique-pme',
    component: IndicationPmeComponent,
    canActivate: [IndicationUtmBlockGuard],
  },
];
